import { Pipe, PipeTransform } from '@angular/core';

/**
 * Collars-local clone of the Hedging Grid 'etsQtyToMarketSide' pipe.
 *
 * Collars NEVER imports Hedging Grid (no HG components, no HedgingGridModule) — its UI is rebuilt. The
 * cloned after-state tables (preview + apply) use the SAME template pipe name 'etsQtyToMarketSide' the HG
 * after-state markup uses, so this pipe re-declares that name LOCALLY (own file + own class) for the
 * EtsCollarsModule resolution scope. Behaviour matches the HG pipe: signed qty -> Long / Short / Flat.
 */
@Pipe({
   name: 'etsQtyToMarketSide'
})
export class CollarsQtyToMarketSidePipe implements PipeTransform {
   transform(value: any, ...args: any[]): any {

      if (typeof value === 'object') {
         return undefined;
      }

      let val: number;

      if (typeof value === 'string') {
         val = parseInt(value, 10);
      } else {
         val = value;
      }

      if (val === 0) {
         return 'Flat';
      }

      if (val > 0) {
         return 'Long';
      }

      if (val < 0) {
         return 'Short';
      }

      return 'N/A';
   }
}
